// extracted by mini-css-extract-plugin
export default {"tag":"tag_r_vorAm","tag_active":"tag_active_AH0CJ1W","tag_disabled":"tag_disabled_vfkvmgj","icon":"icon_WiE_2_3"};